/**
 * Common action creators
 */
export const ABORT_CURRENT_TASKS = 'ABORT_CURRENT_TASKS';

/**
 * Create an action to force abortion of any ongoing tasks the user is doing
 * - for example, cancel any alert.
 * @returns {{type: string}}
 */
export function abortCurrentTasks() {
    return { type: ABORT_CURRENT_TASKS };
}
